import { Injectable,Inject } from '@angular/core';

import { Router } from '@angular/router';
import { WINDOW } from './window.service';
import { Observable } from 'rxjs';
import { EmitterService } from './emitter.service';
import { Utility } from '../shared/utility/utility';

@Injectable()
export class DisableDesktopRouteGuardService   {
  langCode;

  constructor(
    private router: Router,
    private emitter: EmitterService,
    private utility:Utility,
    @Inject(WINDOW) private window: Window,
  ) {
    this.langCode = localStorage.getItem('langCode');
  }

  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    //Old Registration flow
    // let ww = document.body.clientWidth;
    // if(ww <= 992) {
    //   return true;
    // } else { 
    //   if(!this.utility.isUserLoggedIn()){
    //     this.utility.registrationCaptureRouteData();
    //     this.emitter.broadCastShowRegModal(true)
    //   }
    //   this.router.navigate([this.langCode]);
    //   return false;

   if(!this.utility.isUserLoggedIn()){
      this.utility.registrationCaptureRouteData();
      this.emitter.broadCastShowRegModal(true);
      this.utility.disablescrollOnRegistrationPageOpend(true);
      return true;
    }else{
      this.router.navigate([this.langCode]);
      return false;
    }
    
  }
}
